import {
  Button,
  Card,
  ContextualMenu,
  FilePicker,
  Group,
  IconDocument,
  IconHelp,
  IconRestore,
  IconTrash,
  Modal,
  OptionInterface,
  OptionValue,
  Table,
  TableColumnWidth,
  TableColumns,
  TableData,
  TablePagination,
  TablePreferences,
  TextArea,
} from "@veneer/core";
import "../../assets/css/views/sellOut/sellOut.css";
import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { useTranslation } from "react-i18next";
import { Workbook, Cell } from "exceljs";
import SellOutService from "../../services/sellOutApi/sellOut.service";
import { ISellOutJson } from "../../models/input/sellOutApi/ISellOutJson";

import {
  IAdditionalData,
  IJsonData,
  ISellOutEmail,
} from "../../models/input/sellOutApi/ISellOutEmail";
import { ISellOutNotification } from "../../models/input/sellOutApi/ISellOutNotification";
import { ModalMessageLoading } from "./SellOutComponent/ModalMessageLoading";
import { IGetSellOutFileListDto } from "../../models/dto/sellOutApi/IGetSellOutFileListDto";
import { ISellOutDelete } from "../../models/input/sellOutApi/ISellOutDelete";
import { ISellOutUpdateActive } from "../../models/input/sellOutApi/ISellOutUpdateActive";
import { ModalQuestion } from "./SellOutComponent/ModalQuestion";
import { ModalInformational } from "./SellOutComponent/ModalInformational";
import { ISellOutMissingProduct } from "../../models/input/sellOutApi/ISellOutMissingProduct";
import useDownloadFiles from "../../hooks/downloadFiles/useDownloadFiles";
import moment from "moment";

type handleChangeType = (
  value: string,
  event: ChangeEvent<HTMLTextAreaElement>
) => void;

export default function SellOut() {
  const [t] = useTranslation("global");
  const languageID: any = useSelector((state: RootState) => state.languageId);
  const [tableData, setTableData] = useState<TableData[]>([]);
  const [tableDataDeleted, setTableDataDeleted] = useState<TableData[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [loading, setLoading] = useState(false);
  const [loadingDeleted, setLoadingDeleted] = useState(false);
  const [openModalHelper, setOpenModalHelper] = useState(false);
  const [openModalRecycleBin, setOpenModalRecycleBin] = useState(false);
  const [openModalCreateSellOut, setOpenModalCreateSellOut] = useState(false);
  const [openModalCreateSellOut2, setOpenModalCreateSellOut2] = useState(false);
  const [openModalError, setOpenModalError] = useState(false);
  const [openModalLoading, setOpenModalLoading] = useState(false);
  const [openModalLoadingExcel, setOpenModalLoadingExcel] = useState(false);
  const [openModalLoadingProduct, setOpenModalLoadingProduct] = useState(false);
  const [openModalLoadingUpdateProduct, setOpenModalLoadingUpdateProduct] =
    useState(false);
  const [openModalLoadingSendEmail, setOpenModalLoadingSendEmail] =
    useState(false);
  const [openModalLoadingEmail, setOpenModalLoadingEmail] = useState(false);
  const [fileName, setFileName] = useState<string>("");
  const [comments, setcomments] = useState<string>("");
  const [errorFilePicker, setErrorFilePicker] = useState(false);
  const [buttonNext, setButtonNext] = useState(true);
  const [jsonDate, setJsonDate] = useState<ISellOutJson[]>([]);
  const [valueFileId, setValueFileId] = useState<number>();
  const [deleteModal, setDeleteModal] = useState(false);
  const [restoreModal, setRestoreModal] = useState(false);
  const [openModalRestoreOk, setOpenModalRestoreOk] = useState(false);
  const [openModalDeleteOk, setOpenModalDeleteOk] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const { downloadFile } = useDownloadFiles();
  const [messageFilePickerError, setMessageFilePickerError] = useState("");

  useEffect(() => {
    getSellOutFileList();
  }, []);

  //Configuracion de la tabla
  const columnsWidth: TableColumnWidth[] = [
    { columnId: "fileName", width: "25%" },
    { columnId: "comments", width: "25%" },
    { columnId: "uploadDate", width: "25%" },
    { columnId: "createdBy", width: "25%" },
  ];

  const tablePreferences: TablePreferences = {
    width: columnsWidth,
  };

  const columns: TableColumns[] = [
    { id: "fileName", label: t("header.fileName") },
    { id: "comments", label: t("header.comments") },
    { id: "uploadDate", label: t("header.uploadDate") },
    { id: "createdBy", label: t("header.createdBy") },
  ];

  const columns2: TableColumns[] = [
    { id: "fileName", label: t("header.fileName") },
    { id: "comments", label: t("header.comments") },
    { id: "uploadDate", label: t("header.uploadDate") },
    { id: "createdBy", label: t("header.createdBy") },
  ];

  const pagedData = tableData.slice(
    (currentPage - 1) * pageSize,
    (currentPage - 1) * pageSize + pageSize
  );

  const pagedDataDeleted = tableDataDeleted.slice(
    (currentPage - 1) * pageSize,
    (currentPage - 1) * pageSize + pageSize
  );

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (
    event: React.MouseEvent<HTMLElement>,
    option: OptionInterface<number>
  ) => {
    setPageSize(option.value);
  };

  const paginationProps: TablePagination = {
    currentPage,
    onPageChange: handlePageChange,
    onPageSizeChange: handlePageSizeChange,
    pageSize,
    totalItems: tableData.length,
  };

  const paginationPropsDeleted: TablePagination = {
    currentPage,
    onPageChange: handlePageChange,
    onPageSizeChange: handlePageSizeChange,
    pageSize,
    totalItems: tableDataDeleted.length,
  };

  const options: OptionInterface[] = [
    { value: 1, label: t("header.delete"), icon: <IconTrash /> },
  ];

  const optionsRestore: OptionInterface[] = [
    { value: 1, label: t("header.restoreSellOut"), icon: <IconRestore /> },
  ];

  const contextualMenu = (sellOutFileId: number) => (
    <ContextualMenu
      onClick={(e: any, option?: OptionInterface<OptionValue> | undefined) => {
        if (option?.label === t("header.delete")) {
          setValueFileId(sellOutFileId);
          setDeleteModal(true);
        }
      }}
      options={options}
    />
  );

  const contextualMenuRestore = (sellOutFileId: number) => (
    <ContextualMenu
      onClick={(e: any, option?: OptionInterface<OptionValue> | undefined) => {
        if (option?.label === t("header.restoreSellOut")) {
          setValueFileId(sellOutFileId);
          setRestoreModal(true);
        }
      }}
      options={optionsRestore}
    />
  );

  //Request
  const getSellOutFileList = () => {
    setLoading(true);
    SellOutService.getSellOutFileList().then(
      (result: IGetSellOutFileListDto[]) => {
        fillData(result);
      }
    );
  };

  const getSellOutFilesDeleted = () => {
    setLoadingDeleted(true);
    SellOutService.getSellOutFilesDeleted().then(
      (result: IGetSellOutFileListDto[]) => {
        fillDataDeleted(result);
      }
    );
  };

  const fillData = (data: IGetSellOutFileListDto[]) => {
    const pagedData: TableData[] = [];

    for (let i = 0; i < data.length; i++) {
      const sellOutFileList: IGetSellOutFileListDto = data[i];
      let tableData: TableData = {};

      tableData = {
        fileName: sellOutFileList.fileName,
        comments: sellOutFileList.comments,
        uploadDate: sellOutFileList.uploadDate,
        createdBy: sellOutFileList.userName,
        rowConfig: {
          action: contextualMenu(sellOutFileList.sellOutFileId),
          disabled: false,
          noWrap: false,
          selected: false,
        },
      };
      pagedData.push(tableData);
    }
    setTableData(pagedData);
    setLoading(false);
  };

  const fillDataDeleted = (data: IGetSellOutFileListDto[]) => {
    const pagedDataDeleted: TableData[] = [];

    for (let i = 0; i < data.length; i++) {
      const sellOutDeleted: IGetSellOutFileListDto = data[i];
      let tableData: TableData = {};

      tableData = {
        fileName: sellOutDeleted.fileName,
        comments: sellOutDeleted.comments,
        uploadDate: sellOutDeleted.uploadDate,
        createdBy: sellOutDeleted.userName,
        rowConfig: {
          action: contextualMenuRestore(sellOutDeleted.sellOutFileId),
          disabled: false,
          noWrap: false,
          selected: false,
        },
      };
      pagedDataDeleted.push(tableData);
    }
    setTableDataDeleted(pagedDataDeleted);
    setLoadingDeleted(false);
  };

  const handleOnCLickNext = () => {
    if (openModalCreateSellOut === true && openModalCreateSellOut2 === false) {
      setOpenModalCreateSellOut(false);
      setOpenModalCreateSellOut2(true);
    }
  };

  const handleOnCLickBack = () => {
    if (openModalCreateSellOut === false && openModalCreateSellOut2 === true) {
      setOpenModalCreateSellOut(true);
      setOpenModalCreateSellOut2(false);
    }
  };

  // JSON
  const getCellRaw = (cell: any) =>
    cell?.text ?? cell?.result ?? cell?.value ?? "";

  const toIntStrict = (input: any): number | null => {
    if (input === null || input === undefined) return null;

    const s = String(input).trim().replace(/,/g, "").replace(/\s+/g, "");
    if (s === "") return null;

    const n = Number(s);

    if (!Number.isInteger(n)) return null;

    return n;
  };

  const normalizeExcelDate = (cell: any): string | null => {
    const valueCell: any = (cell?.value as any)?.result ?? cell?.value;

    // 3) Texto -> aceptar solo MM/DD/YYYY
    const raw =
      (cell?.text ?? "").toString().trim() ||
      (typeof valueCell === "string" ? valueCell.trim() : "");
    if (raw) {
      const parsed = moment.utc(
        raw,
        ["MM/DD/YYYY", "M/D/YYYY", "MM-DD-YYYY", "M-D-YYYY"],
        true
      );
      if (parsed.isValid()) return parsed.format("YYYY-MM-DD");
    }

    return null;
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const fileInput = e.target;

    if (fileInput.files && fileInput.files[0]) {
      const file = fileInput.files[0];
      setFileName(file.name);

      const ext = file.name.split(".").pop()?.toLowerCase();
      if (ext !== "xlsx") {
        setMessageFilePickerError(t("header.messageXLSX"));
        setErrorFilePicker(true);
        return;
      }

      const reader = new FileReader();
      reader.onload = async (event) => {
        try {
          const data = event.target?.result as ArrayBuffer;
          const workbook = new Workbook();
          await workbook.xlsx.load(data);

          const rows: any[] = [];
          const errors: Array<{ row: number; field: string; value: any }> = [];

          workbook.eachSheet((worksheet) => {
            worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
              if (rowNumber === 1) return; // header

              const posCode = String(getCellRaw(row.getCell(1))).trim();
              const dateISO = normalizeExcelDate(row.getCell(2) as Cell);
              const sku = String(getCellRaw(row.getCell(3))).trim();

              const unitsRaw = getCellRaw(row.getCell(4));
              const stockRaw = getCellRaw(row.getCell(5));
              const activeRaw = getCellRaw(row.getCell(6));

              const units = toIntStrict(unitsRaw);
              const stock = toIntStrict(stockRaw);
              const active: boolean | null =
                toIntStrict(activeRaw) === 1
                  ? true
                  : toIntStrict(activeRaw) === 0
                  ? false
                  : null; // this is used to validate the value if is entered or not

              if (units === null)
                errors.push({
                  row: rowNumber,
                  field: "Units",
                  value: unitsRaw,
                });
              if (stock === null)
                errors.push({
                  row: rowNumber,
                  field: "Stock",
                  value: stockRaw,
                });
              if (!dateISO)
                errors.push({
                  row: rowNumber,
                  field: "Date",
                  value: getCellRaw(row.getCell(2)),
                });
              if (active === null)
                errors.push({
                  row: rowNumber,
                  field: "Active",
                  value: getCellRaw(row.getCell(6)),
                });

              rows.push({
                PosCode: posCode,
                Date: dateISO, // YYYY-MM-DD o null
                Sku: sku,
                Units: units, // <-- siempre int o null
                Stock: stock, // <-- siempre int o null
                active: active, // <-- siempre bit
              });
            });
          });
          setButtonNext(false);

          setJsonDate(rows);
          if (rows.length === 0) {
            setMessageFilePickerError(t("modal.dataNotFoundInFile"));
            setErrorFilePicker(true);
            setButtonNext(true);
          }
          if (errors.length > 0) {
            setMessageFilePickerError(
              t("header.errorsDetectedRows")
                .replace("{0}", errors[0].row.toString())
                .replace("{1}", errors[0].field)
            );
            setErrorFilePicker(true);
            setButtonNext(true);
          }
        } catch (err) {
          console.error(err);
          setErrorFilePicker(true);
          setButtonNext(true);
        } finally {
          fileInput.value = "";
        }
      };

      reader.readAsArrayBuffer(file);
    }
  };

  const onClearFilePicker = () => {
    setFileName("");
    setButtonNext(true);
    setErrorFilePicker(false);
  };

  const handleOnClickExit = () => {
    setOpenModalCreateSellOut(false);
    setFileName("");
    setcomments("");
    setButtonNext(true);
  };

  const handleOnClickOpenCreate = () => {
    setFileName("");
    setcomments("");
    setButtonNext(true);
    setOpenModalCreateSellOut(true);
    setErrorFilePicker(false);
  };

  const onChangeTexArea: handleChangeType = useCallback((value, event) => {
    setcomments(value);
  }, []);

  const closeAllModal = () => {
    setOpenModalLoading(false);
    setOpenModalLoadingExcel(false);
    setOpenModalLoadingProduct(false);
    setOpenModalLoadingUpdateProduct(false);
    setOpenModalLoadingEmail(false);
    setOpenModalRecycleBin(false);
    setDeleteModal(false);
    setRestoreModal(false);
  };

  const onclickSave = async () => {
    setErrorMessage(null);

    const formSellOutFile = {
      FileName: fileName,
      Comments: comments,
      UserID: 0,
    };

    try {
      for (let i = 0; i < jsonDate.length; i++) {
        const item = jsonDate[i];
        if (item.Date === "Invalid date") {
          setErrorMessage(t("modal.incorrectformat"));
          setOpenModalError(true);
          return;
        }
      }

      const sellOutFileID = await SellOutService.sellOutFile(formSellOutFile);

      const deleteSellOutEmpty = async (sellOutFile: number) => {
        const formSellOutDelete: ISellOutDelete = {
          SellOutID: sellOutFile,
          userID: 0,
        };

        await SellOutService.deleteSellOutEmpty(formSellOutDelete);
      };

      setOpenModalCreateSellOut2(false);
      setOpenModalLoading(true);

      const sellOutLocal = await SellOutService.sellOutLocal(
        jsonDate,
        sellOutFileID
      );

      if (sellOutLocal === 1) {
        const formSellOut = {
          SellOutFileID: sellOutFileID,
          LanguageID: languageID.value,
        };

        setOpenModalLoading(false);
        setOpenModalLoadingExcel(true);

        const jsonData: IJsonData[] = await SellOutService.sellOut(formSellOut);

        if (jsonData.length <= 1) {
          closeAllModal();
          setErrorMessage(t("modal.errorData"));
          setOpenModalError(true);
          await deleteSellOutEmpty(sellOutFileID);
        } else {
          let resultsWithNull = 0;
          let resultsWithoutNull = 0;

          jsonData.map((item) => {
            if (item.result === null) {
              resultsWithNull += 1;
            } else {
              resultsWithoutNull += 1;
            }
          });

          let templateID = 0;

          if (resultsWithNull > 2 && resultsWithoutNull > 2) {
            templateID = 10;
          } else if (resultsWithNull < 2) {
            templateID = 12;
          } else {
            templateID = 11;
          }

          let userID = 0;
          let fileName = formSellOutFile.FileName.split(".")[0];
          let errorFileName = formSellOutFile.FileName.split(".")[0] + "_Error";
          const language = languageID.value;

          setOpenModalLoadingExcel(false);
          setOpenModalLoadingProduct(true);

          const getMissingProduct = await SellOutService.getMissingProduct(
            userID,
            sellOutFileID
          );

          const sku = getMissingProduct.map(
            (item: ISellOutMissingProduct) => item.sku
          );

          setOpenModalLoadingProduct(false);
          setOpenModalLoadingUpdateProduct(true);

          const pcbProducts: IAdditionalData = await SellOutService.pcbProducts(
            sku
          );

          setOpenModalLoadingUpdateProduct(false);
          setOpenModalLoadingEmail(true);

          const sellOutNotification: ISellOutNotification[] =
            await SellOutService.sellOutNotification(
              userID,
              templateID,
              language,
              fileName,
              errorFileName
            );

          const emailModel: ISellOutEmail = {
            from: sellOutNotification[0].from,
            cc: sellOutNotification[0].cc,
            to: sellOutNotification[0].to,
            subject: sellOutNotification[0].subject,
            body: sellOutNotification[0].body,
            jsonData: jsonData,
            additionalData: pcbProducts,
            fileName: fileName,
          };

          const sendEmail = await SellOutService.sendEmailSellOut(emailModel);

          if (sendEmail === 1 || sendEmail === 2) {
            setOpenModalLoadingEmail(false);
            setOpenModalLoadingSendEmail(true);
          } else {
            closeAllModal();
            setErrorMessage(t("modal.problemSendEmail"));
            setOpenModalError(true);
            await deleteSellOutEmpty(sellOutFileID);
          }
        }
      } else {
        closeAllModal();
        setErrorMessage(t("modal.errorProcessingData"));
        setOpenModalError(true);
        await deleteSellOutEmpty(sellOutFileID);
      }
    } catch (error) {
      closeAllModal();
      setOpenModalError(true);
    }
  };

  const onClickDelete = async () => {
    try {
      if (valueFileId !== undefined) {
        const formSellOutDelete: ISellOutDelete = {
          SellOutID: valueFileId,
          userID: 0,
        };

        const DeleteSellOut = await SellOutService.deleteSellOut(
          formSellOutDelete
        );

        if (DeleteSellOut === 1) {
          getSellOutFileList();
          setDeleteModal(false);
        } else {
          closeAllModal();
          setOpenModalError(true);
        }
      }
    } catch (error) {
      closeAllModal();
      setOpenModalError(true);
    }
  };

  const onClickRestore = async () => {
    try {
      if (valueFileId !== undefined) {
        const formSellOutDelete: ISellOutUpdateActive = {
          SellOutFileID: valueFileId,
          UserID: 0,
          Deleted: false,
        };
        const RestoreSellOut = await SellOutService.UpdateSellOutActivate(
          formSellOutDelete
        );
        if (RestoreSellOut === 1) {
          getSellOutFilesDeleted();
          setRestoreModal(false);
        } else {
          closeAllModal();
          setOpenModalError(true);
        }
      }
    } catch (error) {
      closeAllModal();
      setOpenModalError(true);
    }
  };

  const handleOnCLickRecycleBin = async () => {
    setOpenModalRecycleBin(true);
    try {
      getSellOutFilesDeleted();
    } catch (error) {
      closeAllModal();
      setOpenModalError(true);
    }
  };

  const onClickCloseRecycleBin = () => {
    getSellOutFileList();
    setOpenModalRecycleBin(false);
  };

  return (
    <>
      <div style={{ padding: "1%" }}>
        <h4>{t("header.sellOut")}</h4>
      </div>
      <Button style={{ margin: "5px" }} onClick={handleOnClickOpenCreate}>
        {t("header.createSellOut")}
      </Button>

      <Button style={{ margin: "5px" }} onClick={handleOnCLickRecycleBin}>
        {t("header.recycleBin")}
      </Button>

      <div className="tooltip">
        <span className="tooltiptext">{t("header.downloadFile")}</span>
        <Button
          style={{ margin: "5px" }}
          leadingIcon={<IconDocument />}
          onClick={() =>
            downloadFile("NEWFORMATSELLOUT.xlsx", "xlsx", "sellout_format")
          }
        ></Button>
      </div>

      <div className="tooltip">
        <span className="tooltiptext">
          {t("modal.titleHelper").replace(":", "?")}
        </span>
        <Button
          style={{ margin: "5px" }}
          leadingIcon={<IconHelp />}
          onClick={() => setOpenModalHelper(true)}
        ></Button>
      </div>

      <div style={{ padding: "20px" }}>
        <Card
          appearance="outlined"
          className="divTableSellOut"
          content={
            <Table
              className="tableSellOut"
              behavior={{
                type: "singlePage",
              }}
              columnResize
              loading={loading}
              columns={columns}
              data={pagedData}
              loadingDataLength={5}
              preferences={tablePreferences}
              pagination={paginationProps}
            />
          }
        />
      </div>

      <ModalInformational
        idKey="modal-helper"
        setOpenCloseModal={() => setOpenModalHelper(false)}
        openModal={openModalHelper}
        titleMessage={t("modal.titleHelper")}
        message={t("modal.helperSellOut")}
        onClickOk={() => setOpenModalHelper(false)}
      />

      <Modal
        className="customModalWidth"
        align="center"
        id="modal-RecycleBin"
        show={openModalRecycleBin}
        onClose={() => setOpenModalRecycleBin(false)}
        footer={
          <div className="modal-footer">
            <Button onClick={onClickCloseRecycleBin}>
              {t("header.closebutton")}
            </Button>
          </div>
        }
        title={t("header.recycleBin")}
      >
        <div style={{ padding: "3px" }}>
          <Card
            appearance="outlined"
            className="divTableSellOutRestore"
            content={
              <Table
                className="tableSellOutRestore"
                behavior={{
                  type: "singlePage",
                }}
                columnResize
                loading={loadingDeleted}
                columns={columns2}
                data={pagedDataDeleted}
                loadingDataLength={5}
                preferences={tablePreferences}
                pagination={paginationPropsDeleted}
              />
            }
          />
        </div>
      </Modal>

      <div style={{ position: "relative" }}>
        <Modal
          align="center"
          id="modal-createSellOut"
          show={openModalCreateSellOut}
          onClose={() => setOpenModalCreateSellOut(false)}
          footer={
            <div className="buttonGroup">
              <Group>
                <Button onClick={handleOnClickExit} appearance="secondary">
                  {t("header.closebutton")}
                </Button>
                <Button disabled={buttonNext} onClick={handleOnCLickNext}>
                  {t("header.next")}
                </Button>
              </Group>
            </div>
          }
          title={t("header.createSellOut")}
        >
          <div>
            <h5>{t("header.uploadFile")}</h5>
            <FilePicker
              className="modalSellOutFile"
              id="selOut-file-picker"
              label={t("header.uploadFile")}
              accept=".xlsx"
              onChange={handleFileChange}
              onClear={onClearFilePicker}
              value={fileName}
              error={errorFilePicker}
              helperText={messageFilePickerError}
            />
          </div>
        </Modal>
      </div>

      <div style={{ position: "relative" }}>
        <Modal
          align="center"
          id="modal-createSellOut"
          show={openModalCreateSellOut2}
          onClose={() => setOpenModalCreateSellOut(false)}
          footer={
            <div className="buttonGroup">
              <Group>
                <Button appearance="secondary" onClick={handleOnCLickBack}>
                  {t("header.back")}
                </Button>
                <Button onClick={onclickSave}>{t("header.save")}</Button>
              </Group>
            </div>
          }
          title={t("header.createSellOut")}
        >
          <div>
            <h5>{t("header.comments")}</h5>
            <TextArea
              id="textArea"
              value={comments}
              onChange={onChangeTexArea}
            />
          </div>
        </Modal>
      </div>

      <ModalQuestion
        id="modal-Error"
        setOpenCloseModal={() => setOpenModalError(false)}
        openModal={openModalError}
        titleMessage={t("modal.message")}
        message={errorMessage !== null ? errorMessage : t("modal.generalError")}
        onClickYes={() => setOpenModalError(false)}
        onClickNo={() => setOpenModalError(false)}
        titleButtonYes="OK"
        titleButtonNo={t("header.cancel")}
      />

      <ModalMessageLoading
        id="modal-processingfile"
        setOpenCloseModal={() => setOpenModalLoading(false)}
        openModal={openModalLoading}
        titleMessage={t("header.loading")}
        message={t("modal.processingfile")}
      />

      <ModalMessageLoading
        id="modal-savingInformation"
        setOpenCloseModal={() => setOpenModalLoadingExcel(false)}
        openModal={openModalLoadingExcel}
        titleMessage={t("header.loading")}
        message={t("modal.savingInformation")}
      />

      <ModalMessageLoading
        id="modal-verifyingProducts"
        setOpenCloseModal={() => setOpenModalLoadingProduct(false)}
        openModal={openModalLoadingProduct}
        titleMessage={t("header.loading")}
        message={t("modal.verifyingProducts")}
      />

      <ModalMessageLoading
        id="modal-updatingProducts"
        setOpenCloseModal={() => setOpenModalLoadingUpdateProduct(false)}
        openModal={openModalLoadingUpdateProduct}
        titleMessage={t("header.loading")}
        message={t("modal.updatingProducts")}
      />

      <ModalMessageLoading
        id="modal-preparingMail"
        setOpenCloseModal={() => setOpenModalLoadingEmail(false)}
        openModal={openModalLoadingEmail}
        titleMessage={t("header.loading")}
        message={t("modal.preparingMail")}
      />

      <ModalInformational
        idKey="modal-mailSent"
        setOpenCloseModal={() => setOpenModalLoadingSendEmail(false)}
        openModal={openModalLoadingSendEmail}
        titleMessage={t("header.loading")}
        message={t("modal.mailSent")}
        onClickOk={() => setOpenModalLoadingSendEmail(false)}
      />

      <ModalQuestion
        id="modal-Delete"
        setOpenCloseModal={() => setDeleteModal(false)}
        openModal={deleteModal}
        titleMessage={t("modal.message")}
        message={t("modal.questionDeleteSellOut")}
        onClickYes={onClickDelete}
        onClickNo={() => setDeleteModal(false)}
        titleButtonYes={t("header.yes")}
        titleButtonNo={t("header.no")}
      />

      <ModalQuestion
        id="modal-Restore"
        setOpenCloseModal={() => setRestoreModal(false)}
        openModal={restoreModal}
        titleMessage={t("modal.message")}
        message={t("modal.questionRestoreSellOut")}
        onClickYes={onClickRestore}
        onClickNo={() => setRestoreModal(false)}
        titleButtonYes={t("header.yes")}
        titleButtonNo={t("header.no")}
      />

      <ModalInformational
        idKey="modal-deleteOk"
        setOpenCloseModal={() => setOpenModalDeleteOk(false)}
        openModal={openModalDeleteOk}
        titleMessage={t("modal.message")}
        message={t("modal.deleteSellOut")}
        onClickOk={() => setOpenModalDeleteOk(false)}
      />

      <ModalInformational
        idKey="modal-RestoreOk"
        setOpenCloseModal={() => setOpenModalRestoreOk(false)}
        openModal={openModalRestoreOk}
        titleMessage={t("modal.titleHelper")}
        message={t("modal.restoreSellOut")}
        onClickOk={() => setOpenModalRestoreOk(false)}
      />
    </>
  );
}
